import activityPrompt from 'emun.activity/activity-prompt';
import $session from 'servicestack/session';
import resolve from 'ioc/resolve';

function ActivityPromptDirective($window, $parse) {
    // Introduce custom elements for IE8
    $window.document.createElement('activity-prompt');
    return {
        scope: false,
        link: function (scope, element, attr) {
			let onNoteCreated = attr.onNoteCreated || attr.onNoteSaved;
            let $targets = (attr.activityPromptClickSelector ? element.find(attr.activityPromptClickSelector) : element);
            $targets.on('click', e => {
                var model = scope.$eval(attr.activityPrompt || attr.ngModel || attr.customer || attr.prospect || attr.activity || attr.startDate) || {
                    customer: attr.customer,
                    prospect: attr.prospect,
					activity: attr.activity,
                    prospectMode: attr.prospectMode,
                    startDate: attr.startDate
                };
                activityPrompt.open({ title: attr.title, scope, attr, element, $targets, model }).then(
                    (saved) => {
                        if (attr.onActivitySaved) {
                            $parse(attr.onActivitySaved)(scope, { $saved: saved })
                        }
                    }, () => {
                        if (attr.onDismissed) {
                          $parse(attr.onDismissed)(scope, {});
                        }
                    });
            });
        }
    }
};

export default ActivityPromptDirective;